import { APP_LANGUAGES, DEFAULT_LOCALE } from '../../config/common.config';

export const getLocaleFromPathname = (pathname: string): string =>
  pathname.replace(/^\//, '').split('/')[0];

// the website url uses "jp" (e.g. native-instruments.com/jp)
// but "jp" is not a standard intl locale so we need those
export const convertToUrlLocale = (locale: string): string =>
  locale === 'ja' ? 'jp' : locale;

export const getIntlValidLocale = (locale: string): string => {
  const intlValidLocale = locale === 'jp' ? 'ja' : locale;
  return APP_LANGUAGES.includes(locale) ? intlValidLocale : DEFAULT_LOCALE;
};
